import { render, staticRenderFns } from "./EmailCard.vue?vue&type=template&id=6e4b2017&scoped=true&"
import script from "./EmailCard.vue?vue&type=script&lang=js&"
export * from "./EmailCard.vue?vue&type=script&lang=js&"
import style0 from "./EmailCard.vue?vue&type=style&index=0&id=6e4b2017&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4b2017",
  null
  
)

export default component.exports